import React, {useContext} from 'react';
import {BlazeSessionContext} from '../../context'
import dynamic from 'next/dynamic';
import useInBrowser from '../../hooks/useInBrowser';
import {useMediaQuery} from 'react-responsive';

const BlazeLanding = dynamic(() => import('../../containers/blaze/BlazeLanding'))

export default function BlazeScreen() {
	const [, setIsPopupOpen] = useContext(BlazeSessionContext).openBookingPopup;
	const [isLoading, setIsLoading] = useContext(BlazeSessionContext).blazePageLoading;
	const inBrowser = useInBrowser();
	const isSmallScreen = useMediaQuery({ query: "(max-width: 500px)" });

	return !isLoading && !isSmallScreen && inBrowser && (<BlazeLanding openPopUp={() => setIsPopupOpen(true)} />);
}

BlazeScreen.getLayout = 'Blaze'

// BlazeScreen.Layout = BlazeLayout;
